import { ABOUT_US_PATH, CONTACT_US_PATH, FAQ_PATH, HOME_PATH, TERMS_PATH } from "constants/app-paths"
import { lazy } from "react"

//public
const Home = lazy(() => import("pages/public/home"))
const AboutUs = lazy(() => import("pages/public/aboutUs"))
const ContactUs = lazy(() => import("pages/public/contactUs"))
const Terms = lazy(() => import("pages/public/terms"))
const Faqs = lazy(() => import("pages/public/faqs"))
//protected

export const PUBLIC_ROUTES = [
  {
    path: HOME_PATH,
    Component: Home,
    name: "home",
  },
  {
    path: ABOUT_US_PATH,
    Component: AboutUs,
    name: "about_us",
  },
  {
    path: CONTACT_US_PATH,
    Component: ContactUs,
    name: "contact_us",
  },
  {
    path: TERMS_PATH,
    Component: Terms,
    name: "terms_and_conditions",
  },
  {
    path: FAQ_PATH,
    Component: Faqs,
    name: "faqs",
  },
]

export const PROTECTED_ROUTES = []
